import { NavLink, Outlet, useNavigate } from "react-router-dom";
import {
  Gauge, Storefront, CreditCard, Receipt, Lightning, Gear, SignOut, Crown, Plugs, Palette,
  Megaphone,
} from "@phosphor-icons/react";
import { useAuth } from "../context/AuthContext";
import { BrandLogo } from "../context/BrandingContext";

const NAV = [
  { to: "/superadmin", label: "Dashboard", icon: Gauge, end: true },
  { to: "/superadmin/ristoranti", label: "Ristoranti", icon: Storefront },
  { to: "/superadmin/piani", label: "Piani", icon: Crown },
  { to: "/superadmin/abbonamenti", label: "Abbonamenti", icon: CreditCard },
  { to: "/superadmin/pagamenti", label: "Pagamenti", icon: Receipt },
  { to: "/superadmin/eventi", label: "Eventi Billing", icon: Lightning },
  { to: "/superadmin/comunicazioni", label: "Comunicazioni", icon: Megaphone },
  { to: "/superadmin/integrazioni", label: "Integrazioni", icon: Plugs },
  { to: "/superadmin/branding", label: "Branding", icon: Palette },
  { to: "/superadmin/impostazioni", label: "Impostazioni", icon: Gear },
];

export default function SALayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-zinc-950" data-testid="sa-layout">
      <aside className="hidden md:flex fixed inset-y-0 left-0 w-60 flex-col bg-zinc-900 border-r border-zinc-800 z-30">
        <div className="px-5 py-5 border-b border-zinc-800">
          <BrandLogo slot="light" fallbackClass="font-display font-extrabold text-xl tracking-tight text-white" />
          <div className="mt-1">
            <span className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-widest text-amber-400">
              <Crown size={12} weight="fill" /> Super Admin
            </span>
          </div>
        </div>
        <nav className="flex-1 overflow-y-auto py-3 px-2 space-y-0.5">
          {NAV.map(({ to, label, icon: Icon, end }) => (
            <NavLink key={to} to={to} end={end} data-testid={`sa-nav-${label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium transition-colors duration-150 ${
                  isActive ? "bg-amber-400 text-zinc-950" : "text-zinc-400 hover:bg-zinc-800 hover:text-white"}`}>
              <Icon size={18} weight="bold" /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-zinc-800 p-3 flex items-center justify-between">
          <div className="min-w-0">
            <div className="text-sm font-medium text-white truncate">{user?.name}</div>
            <div className="text-xs text-zinc-500">Piattaforma</div>
          </div>
          <button onClick={doLogout} data-testid="sa-logout" title="Esci"
            className="p-2 rounded-md text-zinc-500 hover:bg-zinc-800 hover:text-white transition-colors">
            <SignOut size={18} />
          </button>
        </div>
      </aside>

      <header className="md:hidden sticky top-0 z-30 bg-zinc-900 border-b border-zinc-800 px-4 h-14 flex items-center justify-between">
        <span className="font-display font-extrabold text-lg text-white">DISHENDA <span className="text-amber-400 text-xs">SUPER ADMIN</span></span>
        <button onClick={doLogout} className="p-2 text-zinc-400"><SignOut size={20} /></button>
      </header>
      <nav className="md:hidden bg-zinc-900 border-b border-zinc-800 px-2 py-2 flex gap-1 overflow-x-auto" data-testid="sa-mobile-nav">
        {NAV.map(({ to, label, icon: Icon, end }) => (
          <NavLink key={to} to={to} end={end}
            className={({ isActive }) =>
              `shrink-0 flex items-center gap-1.5 px-3 py-2 rounded-md text-xs font-medium ${
                isActive ? "bg-amber-400 text-zinc-950" : "text-zinc-400"}`}>
            <Icon size={15} weight="bold" /> {label}
          </NavLink>
        ))}
      </nav>

      <main className="md:ml-60 px-3 sm:px-6 py-5 max-w-7xl text-zinc-100">
        <Outlet />
      </main>
    </div>
  );
}
